import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

export const locationRequestConfigsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLocationRequestConfigs: builder.query({
      query: (publisherId) => {
        return {
          url: `/publishers/${publisherId}/sdk/location_request_configs`
        }},
      providesTags: (result = [], error, arg) => [{ type: 'LocationRequestConfig', id: arg }],
    }),
    getDefaultLocationRequestConfig: builder.query({
      query: () => {
        return {
          url: `/sdk/default_config`
        }},
      providesTags: [{ type: 'LocationRequestConfig', id: 'Default' }],
    }),
    updateLocationRequestConfig: builder.mutation({
      query: (locationRequestConfig) => ({
        url: `/publishers/${locationRequestConfig.publisher_id}/sdk/location_request_configs`,
        method: 'POST',
        body: locationRequestConfig
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => [{ type: 'LocationRequestConfig', id: arg.publisher_id }],
    }),
    updateDefaultLocationRequestConfig: builder.mutation({
      query: (locationRequestConfig) => ({
        url: `/sdk/default_config`,
        method: 'PUT',
        body: locationRequestConfig
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: [{ type: 'LocationRequestConfig', id: 'Default' }],
    })
  }),
  overrideExisting: false
})

export const {
  useGetLocationRequestConfigsQuery,
  useUpdateLocationRequestConfigMutation,
  useGetDefaultLocationRequestConfigQuery,
  useUpdateDefaultLocationRequestConfigMutation
} = locationRequestConfigsApiSlice
